import axios from "axios";
// https://api.mapbox.com/search/searchbox/v1/forward?q=privada%25205%2520de%2520febrero%252C%2520San%2520pablo%2520autopan&access_token=pk.eyJ1IjoiYWRtaW4tcmFkYXJpYSIsImEiOiJjbHp2eTM0NjMwY3dtMmpwdjBkMzl2OHQwIn0.bcCiBJuWpvITvalXMIl9kQ
const instanceMapAPI = axios.create({
  baseURL: `https://api.mapbox.com/search/searchbox/v1/`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
instanceMapAPI.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const instanceNavigateMap = axios.create({
  baseURL: `https://api.mapbox.com/directions/v5/mapbox/walking/`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

instanceNavigateMap.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
const instanceMapReverseAPI = axios.create({
  baseURL: "https://api.mapbox.com/search/geocode/v6/",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
instanceMapReverseAPI.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export { instanceMapAPI, instanceNavigateMap, instanceMapReverseAPI };
